import { Component, OnInit } from '@angular/core';
import { RsbLookupModel } from 'src/app/common/model/rsb-lookup.model';
import { RsbService } from 'src/app/service/rsb.service';
@Component({
  selector: 'app-myview-leads',
  templateUrl: './myview-leads.component.html',
  styleUrls: ['./myview-leads.component.css']
})
export class MyviewLeadsComponent implements OnInit {

  getMylead: Array<any> = [
    {
      listingId: 'PB-1001',
      propertyTitle: '3 BHK Apartment at Pillar Heights',
      customerName: 'Amit Sharma',
      cmobile: '9876543210',
      cemail: 'amit.sharma@example.com'
    },
    {
      listingId: 'PB-1002',
      propertyTitle: 'Commercial Space at Grand Avenue',
      customerName: 'Neha Verma',
      cmobile: '9812345678',
      cemail: 'neha.verma@example.com'
    },
    {
      listingId: 'PB-1003',
      propertyTitle: 'Villa at Lakeview Residency',
      customerName: 'Rahul Mehta',
      cmobile: '9898765432',
      cemail: 'rahul.mehta@example.com'
    },
    {
      listingId: 'PB-1004',
      propertyTitle: '2 BHK Apartment at Green Valley',
      customerName: 'Priya Singh',
      cmobile: '9822334455',
      cemail: 'priya.singh@example.com'
    },
    {
      listingId: 'PB-1005',
      propertyTitle: 'Office Floor at Metro Plaza',
      customerName: 'Suresh Iyer',
      cmobile: '9800112233',
      cemail: 'suresh.iyer@example.com'
    },
    {
      listingId: 'PB-1006',
      propertyTitle: '4 BHK Residence at Palm Enclave',
      customerName: 'Ritu Arora',
      cmobile: '9877001122',
      cemail: 'ritu.arora@example.com'
    },
    {
      listingId: 'PB-1007',
      propertyTitle: 'Retail Unit at City Walk',
      customerName: 'Manish Gupta',
      cmobile: '9811223344',
      cemail: 'manish.gupta@example.com'
    },
    {
      listingId: 'PB-1008',
      propertyTitle: '3 BHK Apartment at Sunrise Towers',
      customerName: 'Anjali Rao',
      cmobile: '9899112233',
      cemail: 'anjali.rao@example.com'
    },
    {
      listingId: 'PB-1009',
      propertyTitle: 'Independent House at Silver Park',
      customerName: 'Vikram Shah',
      cmobile: '9833445566',
      cemail: 'vikram.shah@example.com'
    },
    {
      listingId: 'PB-1010',
      propertyTitle: 'Studio Apartment at Urban Nest',
      customerName: 'Pooja Nair',
      cmobile: '9866554433',
      cemail: 'pooja.nair@example.com'
    }
  ];
  constructor(
  private rsbService:RsbService,
  private rsbLookup:RsbLookupModel
) { 
  console.log("mylead")
}

ngOnInit(): void {
}

getMyleads() {
  this.rsbService.myViewLeads().subscribe((rsp) => {
    if(rsp.statusCode === 0 && rsp.contents) {
    this.getMylead = rsp.contents;
    } else {
      this.getMylead = []
    }
  })

}

}
